import { api } from '@/redux/api/api';
import { QueryHandler } from '@/redux/types/query-handler';
import { addItemRecipe } from '@/redux/utils/add-item-recipe';
import { Unit } from '@/types/unit';
import { CreateUnitQueryArg } from '../types/query-arg';

export const handleResultCreateUnit: QueryHandler<
  CreateUnitQueryArg,
  Omit<Unit, 'devices'>
> = async (queryArg, { dispatch, queryFulfilled }) => {
  // This doesn't need to be optimistic since the creation is on a separate page and shows a completion / loading spinner
  const { data: unit } = await queryFulfilled;

  const newUnit: Unit = {
    id: unit.id,
    unitName: unit.unitName,
    devices: [],
    organisation: unit.organisation,
    group: unit.group,
    uuid: unit.uuid ?? null,
  };

  dispatch(
    api.util.updateQueryData(
      'getUnits',
      { organisation: queryArg.organisation },
      addItemRecipe(newUnit),
    ),
  );
};
